import React from 'react';

import AddIcon from '@material-ui/icons/Add';
import { Button } from '@material-ui/core';

const AddButton = ({ children, ...props }) => {
  return (
    <Button color="default" {...props} variant="contained" disableElevation startIcon={<AddIcon />}>
      {children}
    </Button>
  );
};

export default AddButton;
